export default "__VITE_ASSET__Cp3ViV6U__"